import axiosPost from "./axiosPost";

export const SFHabitacionCambioDo = async (credentials, data) => {
    const body = {
        service: "SFHabitacionCambioDo",
        params: {
            SFHabitacionHuespedId: data.SFHabitacionHuespedId,
            SFHabitacionId: data.SFHabitacionId,
        },
    };

    const result = await axiosPost(body, credentials);
    if (result?.status?.code === 0) {
        return [result.status];
    }
    return result.result;
};
